export default "__VITE_ASSET__wDkONRY8__"